import React from 'react';
import { connect } from 'react-redux';
import CardPaiementCheque from './CardPaiementCheque';
import CardPaiementVirement from './CardPaiementVirement';
import CardChoixAutrePaiement from './CardChoixAutrePaiement';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';


const CardModePaiement = ({
    setChoix, choixModePaiement, Manuel,
}) => {
    switch (choixModePaiement) {
    case 'virement':
        return <CardPaiementVirement setChoix={setChoix} />;
    case 'cheque':
        return <CardPaiementCheque setChoix={setChoix} />;
    default:
        return <CardChoixAutrePaiement setChoix={setChoix} Manuel={Manuel} />;
    }
};

CardModePaiement.displayName = 'CardModePaiement';
CardModePaiement.requiredProps = [

];

function mapStateToProps({
    ProStore: {
        Pro: { Mandat },
    },
}) {
    return { Mandat };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardModePaiement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardAutrePaiement.js